import { Getters } from "vuex-smart-module";
import TargetState from "./state";

export default class TargetGetters extends Getters<TargetState> {
  searchVesselById(mmsi: number) {
    const vessel = this.state.vessels.find((vessel) => vessel.mmsi === mmsi);
    if (vessel === undefined) {
      throw new TypeError("No se encontró el vessel solicitado");
    }
    return vessel;
  }
  searchSarById(mmsi: number) {
    const sar = this.state.sars.find((sar) => sar.mmsi === mmsi);
    if (sar === undefined) {
      throw new TypeError("No se encontró el sar solicitado");
    }
    return sar;
  }
  get targetsLoaded(): boolean {
    return !!this.state.vessels.length;
  }
  get atonsList() {
    return this.state.atons;
  }
  get bsList() {
    return this.state.baseStations;
  }
  get vesselList() {
    return this.state.vessels;
  }
  get sarList() {
    return this.state.sars;
  }
  get selectedVessel() {
    return this.state.selectedVessel;
  }
  get selectedSar() {
    return this.state.selectedSar;
  }
  get targetsTagsEnabled() {
    return this.state.targetsTag;
  }
  get predictionTime() {
    return this.state.predictionTime;
  }
  get aisTargetsCount() {
    return (
      this.state.vessels.length +
      this.state.sars.length +
      this.state.atons.length +
      this.state.baseStations.length
    );
  }
}
